// API Configuration
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://mindit-backend-functions.azurewebsites.net/api',
};

export default config;
